import { z } from 'zod';

export const schemaUTM = z
    .record(z.string(), z.string())
    .and(
        z.object({
            campaign: z.string().optional(),
            content: z.string().optional(),
            medium: z.string().optional(),
            source: z.string().optional(),
            term: z.string().optional(),
        }),
    )
    .nullish()
    .default({});
